import React from 'react';
import './teamCard.css';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';

class TeamCard extends React.Component {
  render() {
    const { item } = this.props;
    return (
      <Card className='team-card' flexWrap='nowrap' align='center'>
        <CardActionArea>
          <CardContent className='team-content'>
            <img className='cardImage' src={item.imageUrl} alt={item.title} />
            <Typography className='team-title'>{item.title}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }
}

export default TeamCard;
